var cibDiscover = ["32 32", "<path d='M16 0c-8.839 0-16 7.161-16 16s7.161 16 16 16c8.839 0 16-7.161 16-16s-7.161-16-16-16z'/>"];

export { cibDiscover };

